import React from 'react';
import './App.css';
import NasaList from './components/NasaList';

function App() {
  return (
    <div className="App">
      <NasaList />
    </div>
  );
}

export default App;
